export default (params = {}) => {
  return {
    description: 'Отчество',
    type: 'string',
    maxLength: 85,
    errorMessage: { maxLength: 'Отчество не может быть длиннее 85 символов' },
    ...params,
  };
};
